import React, { useEffect, useState } from 'react';
import DatahubAPI from '../../api/DatahubAPI';
import { format } from 'date-fns';
import TableRow from './TableRow';
import { Link } from 'react-router-dom';

type Hit = {
  col1: string,
  col2: string,
}

const Updates: React.FC = () => {
  const itemsPerPage = 5;
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ updates, setUpdates ] = useState<Hit[]>([]);
  const [ loaded, setLoaded ] = useState<boolean>(false);
  const [ totalPages, setTotalPages ] = useState(1);
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);


  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(updates?.length / itemsPerPage)));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };


  const dt1 = new Date();
  const dt5 = new Date(dt1);

  dt5.setDate(dt5.getDate() - 4);

  const dateArr: Array<any> = [ dt5, dt1 ];
  dateArr.forEach((dt: any, index: number) => {
    const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
    const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
    dateArr[index] = formatted_dt;
  });

  const extractLensAndListsFlat = (listAggBuckets: any) => {
    const results: any[] = [];

    listAggBuckets.forEach((bucket: any) => {
      const lens = bucket.key;

      const countries = bucket.countryAgg?.buckets || [];
      countries.forEach((country: any) => {
        const agencies = country.agencyAgg?.buckets || [];
        agencies.forEach((agency: any) => {
          const listNames = agency.listNameAgg?.buckets || [];
          listNames.forEach((list: any) => {
            if (list.key) {
              results.push({
                col2: lens,
                col1: list.key
              });
            }
          });
        });
      });
    });

    return results;
  };


  const getUpdates = async() => {
    setLoaded(false);
    const query: any = {
      indices: [ 'bite_app_entities_combined', 'bite_app_commodities_*' ],
      dateRange: dateArr,
      agg: true
    };
    const res = await DatahubAPI.commoditySearch(query);
    if(res?.success && res?.result?.result?.body?.hits?.hits?.length > 0) {
      const arr = extractLensAndListsFlat(res?.result?.result?.body?.aggregations?.listAgg?.buckets);
      setTotalPages(Math.max(1, Math.ceil(arr.length / itemsPerPage)));
      setUpdates(arr);
    }
    setLoaded(true);
  };

  useEffect(() => {
    getUpdates();
  }, []);

  useEffect(() => {
    if (updates.length) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      setCurrentItems(updates.slice(indexOfFirstItem, indexOfLastItem));
    }
  }, [ currentPage, updates ]);

  return (
    <>
      <div className='home-ticket'>
        <div className='home-tickets-header'>
          <div className='home-tickets-header-support'>
            <div className='home-tickets-header-support-badge'>
              <div className='home-tickets-header-support-badge-cont'>
                <div className='home-tickets-header-support-badge-sec'>
                  <div className='home-tickets-header-support-badge-sec-left'>Data Updates</div>
                  <div className='home-tickets-header-support-badge-sec-right'>
                    <Link to='/data/sets'>
                      <div className='home-tickets-header-support-badge-sec-right'>View All</div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='audit-doc-tabe-col'>
          <div className='audit-doc-tabe-col-left-cells'>
            <div>
              <div className='audit-doc-tabe-col-left-cell-text'>List Name</div>
            </div>
          </div>
          <div className='audit-doc-tabe-col-right-cell'>
            <div>
              <div className='audit-doc-tabe-col-left-cell-text'>BITE Lens</div>
            </div>
          </div>
        </div>
        <div className='home-tickets-row'>
          {loaded && currentItems.length ? (
            currentItems?.map((_item: any, index: number) => (
              <React.Fragment key={index}>
                <TableRow key={index} item={_item} tableNable='updates'/>
                {index < 5 && (
                  <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
                )}
              </React.Fragment>
            ))
          ) : loaded && !updates.length ? (
            <div className='homepage-notifications-coming-soon'>
              No Recent Updates
            </div>
          ) : (
            <div className='loader'>Loading...</div>
          )}
        </div>

        <div className='activity-cont-frame-pagination'>
          <div className='activity-cont-frame-pagination-text'>Page {currentPage} of {totalPages}</div>
          <div className='activity-cont-frame-pagination-action'>
            <div className='activity-cont-frame-pagination-action-prev' onClick={handlePrevPage}>
              <div className='activity-cont-frame-pagination-action-text'>Previous</div>
            </div>
            <div className='activity-cont-frame-pagination-action-prev' onClick={handleNextPage}>
              <div className='activity-cont-frame-pagination-action-text'>Next</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Updates;
